import { configureStore } from '@reduxjs/toolkit';
import appSlice from 'store/appSlice';
import userSlice from 'store/userSlice';
import invoiceSlice from 'store/invoiceSlice';
import notificationSlice from 'store/notificationSlice';
import collectionSlice from 'store/collectionSlice';
import { getPreloadedState, saveToLocalStorage } from 'store/localStorage';
import leaveSlice from './leaveSlice';
import salesmanSlice from './salesmanSlice';
import salesmanNotiySlice from './salesmanNotiySlice';
import collectionSalesmanSlice from 'store/collectionSalesmanSlice';

const store = configureStore({
	reducer: {
		app: appSlice,
		user: userSlice,
		invoice: invoiceSlice,
		notification: notificationSlice,
		leave: leaveSlice,
		collection: collectionSlice,
		salesman: salesmanSlice,
		salesmanNotify: salesmanNotiySlice,
		collectionSalesman: collectionSalesmanSlice,
	},
	preloadedState: getPreloadedState(),
});

function onStateChange() {
	saveToLocalStorage(store.getState());
}

store.subscribe(onStateChange);

export default store;
